export const normalizeStoreStatus = (store) => {
  if (store?.status != null) {
    const s = String(store.status).trim().toLowerCase();
    if (s === "inactive" || s === "false" || s === "0") return "inactive";
    if (s === "active" || s === "true" || s === "1") return "active";
    return s;
  }
  if (store?.isActive != null) {
    return store.isActive ? "active" : "inactive";
  }
  if (store?.activeStatus != null) {
    return store.activeStatus ? "active" : "inactive";
  }
  if (store?.storeStatus != null) {
    const s = String(store.storeStatus).trim().toLowerCase();
    if (s === "inactive" || s === "false" || s === "0") return "inactive";
    if (s === "active" || s === "true" || s === "1") return "active";
    return s;
  }
  return "active";
};

export const availableInventoryStores = (stores) => {
  return (stores || []).filter((store) => normalizeStoreStatus(store) === "active");
};
